import React from 'react';
import { Button } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import { WideBox, FlexDiv } from '../../styles/styles';
import VoucherTransactionForm from '../VoucherTransactionForm';

const NewVoucherTransaction = () => {
  const history = useHistory();
  const { authStore } = useRootStore();
  const { voucherID: passedVoucherId } = useParams();

  return (
    <FlexDiv>
      <WideBox showoverflow={1} style={{ maxWidth: '500px' }}>
        <VoucherTransactionForm
          voucherId={passedVoucherId}
          onSubmit={async values => {
            const {
              VoucherId,
              CategoryId,
              AccountId,
              Price,
              Quantity,
              Description,
            } = values;
            try {
              await authStore.request.post(
                `${process.env.REACT_APP_API}/api/voucher-transaction`,
                {
                  VoucherId,
                  CategoryId,
                  AccountId,
                  Price,
                  Quantity,
                  Description,
                },
              );
              history.push(`/vouchers/${passedVoucherId}`);
            } catch (e) {
              console.error(e);
            }
          }}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default NewVoucherTransaction;
